import { chatStoreSupabase } from './Chat.store';

const CHAT_MESSAGE_MAX_LENGTH = 300;

export class ChatUtilities {
    public static handleError(error?: unknown, isBlocking = true): void {
        if (!error) {
            chatStoreSupabase.resetError();
            return;
        }

        let errorMessage = '';

        if ((error as { message: string }).message) {
            errorMessage = (error as { message: string }).message;
        } else if (error instanceof Error) {
            errorMessage = error.message;
        } else if (typeof error === 'string') {
            errorMessage = error;
        }

        if (errorMessage.match(/\[\w+\]/g)) {
            errorMessage = errorMessage.replace(/\[\w+\]/g, '').trim();
        }

        console.error('Supabase Chat Error: ', errorMessage, error);

        chatStoreSupabase.setError({ message: errorMessage, isBlocking });
    }

    public static isValidMessage(message: string): boolean {
        if (!message || !message.trim() || message.length > CHAT_MESSAGE_MAX_LENGTH) {
            return false;
        }
        return true;
    }
}
